import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { handleActivateDialogClose } from '../../../../../common/properties/formFunctions';

class ActivateDialog extends React.Component {
  activateProperty = (e) => {
    const { component, propertyId, updatePropertyWithImages } = this.props;
    e.preventDefault();
    const updatedProperty = { id: propertyId, active: true };
    handleActivateDialogClose(component);
    updatePropertyWithImages(updatedProperty, []);
  }

  render() {
    const { component, confirmActivate } = this.props;

    const activatePropertyActions = [
      <FlatButton
        label="Hætta við" labelStyle={{ color: '#222222' }}
        onTouchTap={() => handleActivateDialogClose(component)}
      />,
      <FlatButton
        label="Virkja" labelStyle={{ color: '#00e39a' }}
        onTouchTap={this.activateProperty}
      />,
    ];

    return (
      <Dialog
        title="Virkja auglýsingu" actions={activatePropertyActions}
        modal={false} open={confirmActivate}
        onRequestClose={() => handleActivateDialogClose(component)}
      >
        Ertu viss um að þú viljir virkja þessa eign? <br /> <br />
        Eignun mun þá birtast öðrum notendum og er þá til leigu.
      </Dialog>
    );
  }
}

ActivateDialog.propTypes = {
  component: React.PropTypes.any.isRequired,
  propertyId: React.PropTypes.string.isRequired,
  confirmActivate: React.PropTypes.bool.isRequired,
  updatePropertyWithImages: React.PropTypes.func.isRequired,
};

export default ActivateDialog;



// WEBPACK FOOTER //
// ./src/browser/app/components/Dialogs/ActivateDialog/ActivateDialog.js